import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/LoginPage.vue"),
  },
  {
    path: "/student/login",
    name: "student/login",
    component: () => import("./views/student/StudentLoginPage.vue"),
  },
  {
    path: "/teacher/login",
    redirect: (to) => {
      return { path: "/student/login", query: to.query };
    },
  },
  {
    path: "/librarian/login",
    redirect: (to) => {
      return { path: "/student/login", query: to.query };
    },
  },
  {
    path: "/librarian",
    component: () => import("./components/LibrarianLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "home",
        name: "/librarian/home",
        component: () => import("./views/librarian/LibrarianHomePage.vue"),
      },
      {
        path: "history",
        name: "/librarian/history",
        component: () => import("./views/librarian/LibrarianHistoryPage.vue"),
      },
      {
        path: "profile",
        name: "/librarian/profile",
        component: () => import("./views/librarian/LibrarianProfilePage.vue"),
      },
      {
        path: "student/:id",
        name: "/librarian/student-detail",
        component: () =>
          import("./views/librarian/LibrarianStudentDetailPage.vue"),
      },
    ],
  },
  {
    path: "/teacher",
    component: () => import("./components/TeacherLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "home",
        name: "/teacher/home",
        component: () => import("./views/teacher/TeacherHomePage.vue"),
      },
      {
        path: "schedule",
        name: "/teacher/schedule",
        component: () => import("./views/teacher/TeacherSchedulePage.vue"),
      },
      {
        path: "attendance",
        name: "/teacher/attendance",
        component: () => import("./views/teacher/TeacherAttendancesPage.vue"),
      },
      {
        path: "grades",
        name: "/teacher/grades",
        component: () => import("./views/teacher/TeacherGradesPage.vue"),
      },
      {
        path: "homework",
        name: "/teacher/homework",
        component: () => import("./views/teacher/TeacherHomeworkPage.vue"),
      },
      {
        path: "notices",
        name: "/teacher/notices",
        component: () => import("./views/teacher/TeacherNoticesPage.vue"),
      },
      {
        path: "notifications",
        name: "/teacher/notifications",
        component: () => import("./views/teacher/TeacherNotificationsPage.vue"),
      },
      {
        path: "profile",
        name: "/teacher/profile",
        component: () => import("./views/teacher/TeacherProfilePage.vue"),
      },
      {
        path: "change-password",
        name: "/teacher/change-password",
        component: () => import("./views/teacher/TeacherChangePasswordPage.vue"),
      },
      {
        path: "settings",
        name: "/teacher/settings",
        component: () => import("./views/teacher/TeacherSettings.vue"),
      },
      {
        path: "student/:id",
        name: "/teacher/student-detail",
        component: () => import("./views/teacher/TeacherStudentDetailPage.vue"),
      },
    ],
  },
  {
    path: "/notice",
    redirect: (to) => {
      return { path: "/student/notices", query: to.query };
    },
  },
  {
    path: "/student",
    component: () => import("./components/StudentLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "home",
        name: "/student/home",
        component: () => import("./views/student/StudentHomePage.vue"),
      },
      {
        path: "schedule",
        name: "/student/schedule",
        component: () => import("./views/student/StudentSchedulePage.vue"),
      },
      {
        path: "grades",
        name: "/student/grades",
        component: () => import("./views/student/StudentGradesPage.vue"),
      },
      {
        path: "notifications",
        name: "/student/notifications",
        component: () => import("./views/student/StudentNotificationsPage.vue"),
      },
      {
        path: "attendance",
        name: "/student/attendance",
        component: () => import("./views/student/StudentAttendancesPage.vue"),
      },
      {
        path: "profile",
        name: "/student/profile",
        component: () => import("./views/student/StudentProfilePage.vue"),
      },
      {
        path: "change-password",
        name: "/student/change-password",
        component: () => import("./views/student/StudentChangePasswordPage.vue"),
      },
      {
        path: "homework",
        name: "/student/homework",
        component: () => import("./views/student/StudentHomeworkPage.vue"),
      },
      {
        path: "settings",
        name: "/student/settings",
        component: () => import("./views/student/StudentSettings.vue"),
      },
      {
        path: "notices",
        name: "/student/notices",
        component: () => import("./views/student/StudentNoticesPage.vue"),
      },
    ],
  },
  {
    path: "/student/scan-attendance",
    name: "student/scan-attendance",
    component: () => import("./views/student/StudentScanAttendancePage.vue"),
  },
  {
    path: "/student/error",
    name: "student/error",
    component: () => import("./views/student/ErrorPage.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("./views/HomePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/register-student",
    name: "register-student",
    component: () => import("./views/RegisterStudentPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/public-register",
    name: "public-register",
    component: () => import("./views/PublicRegisterStudentPage.vue"),
  },
  {
    path: "/students",
    name: "list-students",
    component: () => import("./views/ListStudentsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pending-registrations",
    name: "pending-registrations",
    component: () => import("./views/PendingRegistrationsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/send-notice",
    name: "send-notice",
    component: () => import("./views/SendNoticeSectionPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/studentdetail",
    name: "student-detail",
    component: () => import("./views/StudentPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/grades",
    name: "grades",
    component: () => import("./views/GradesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/grade",
    name: "grade",
    component: () => import("./views/GradePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/gradeform",
    name: "gradeform",
    component: () => import("./views/GradeFormPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/attendances",
    name: "attendances",
    component: () => import("./views/AttendancesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/attendance",
    name: "attendance",
    component: () => import("./views/AttendancePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/attendanceform",
    name: "attendanceform",
    component: () => import("./views/AttendanceFormPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/attendance/report",
    name: "attendance-report",
    component: () => import("./views/AttendanceReportPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/score-deduction",
    name: "score-deduction",
    component: () => import("./views/ScoreDeductionPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/score-deduction",
    name: "reports/score-deduction",
    component: () => import("./views/ReportScoreDeduction.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/schedules",
    name: "schedules",
    component: () => import("./views/SchedulesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/schedule",
    name: "schedule",
    component: () => import("./views/SchedulePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/scheduleform",
    name: "scheduleform",
    component: () => import("./views/ScheduleFormPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/homework",
    name: "homework",
    component: () => import("./views/HomeworkPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("./views/ProfilePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/notices",
    name: "notices",
    component: () => import("./views/NoticesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/all-notices",
    name: "all-notices",
    component: () => import("./views/AllNoticesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/sections",
    name: "settings-sections",
    component: () => import("./views/settings/SectionsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/schools",
    name: "settings-schools",
    component: () => import("./views/settings/SchoolsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/faculties",
    name: "Faculties",
    component: () => import("./views/settings/FacultiesPage.vue"),
  },
  {
    path: "/settings/ethnics",
    name: "settings-ethnics",
    component: () => import("./views/settings/EthnicsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/provinces",
    name: "settings-provinces",
    component: () => import("./views/settings/ProvincesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/districts",
    name: "settings-districts",
    component: () => import("./views/settings/DistrictsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/majorities",
    name: "settings-majorities",
    component: () => import("./views/settings/MajoritiesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/majority",
    name: "settings-majority",
    component: () => import("./views/settings/MajorityPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/batches",
    name: "settings-batches",
    component: () => import("./views/settings/BatchesPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/rooms",
    name: "settings-rooms",
    component: () => import("./views/settings/RoomsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/subjects",
    name: "settings-subjects",
    component: () => import("./views/settings/SubjectsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/users",
    name: "settings-users",
    component: () => import("./views/settings/UsersPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/subject",
    name: "settings-subject",
    component: () => import("./views/settings/SubjectPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/grading",
    name: "settings-grading",
    component: () => import("./views/settings/GradeConfigPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/system",
    name: "settings-system",
    component: () => import("./views/settings/SystemManagementPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings/export-students",
    name: "settings-export-students",
    component: () => import("./views/settings/ExportStudentsPage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/student-gender",
    name: "report-student-gender",
    component: () => import("./views/ReportStudentGender.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/student-born-province",
    name: "report-student-born-province",
    component: () => import("./views/ReportStudentBornProvince.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/student-current-province",
    name: "report-student-current-province",
    component: () => import("./views/ReportStudentCurrentProvince.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/student-majority",
    name: "report-student-majority",
    component: () => import("./views/ReportStudentMajority.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/grade",
    name: "report-grade",
    component: () => import("./views/ReportGradePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/attendance",
    name: "report-attendance",
    component: () => import("./views/ReportAttendancePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/student-section",
    name: "report-student-section",
    component: () => import("./views/ReportStudentSection.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/student-status",
    name: "report-student-status",
    component: () => import("./views/ReportStudentStatus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/top-absent",
    name: "report-top-absent",
    component: () => import("./views/ReportTopAbsent.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/subject-performance",
    name: "report-subject-performance",
    component: () => import("./views/ReportSubjectPerformance.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/enrollment-trends",
    name: "report-enrollment-trends",
    component: () => import("./views/ReportEnrollmentTrends.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/performance-groups",
    name: "report-performance-groups",
    component: () => import("./views/ReportPerformanceGroups.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/teacher-teaching",
    name: "report-teacher-teaching",
    component: () => import("./views/ReportTeacherTeaching.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/top-scoring",
    name: "report-top-scoring",
    component: () => import("./views/ReportTopScoringStudents.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/overall-reports/student-section",
    name: "overall-report-student-section",
    component: () => import("./views/ReportStudentSection.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/student-status",
    name: "overall-report-student-status",
    component: () => import("./views/ReportStudentStatus.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/student-gender",
    name: "overall-report-student-gender",
    component: () => import("./views/ReportStudentGender.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/student-born-province",
    name: "overall-report-student-born-province",
    component: () => import("./views/ReportStudentBornProvince.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/student-current-province",
    name: "overall-report-student-current-province",
    component: () => import("./views/ReportStudentCurrentProvince.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/student-majority",
    name: "overall-report-student-majority",
    component: () => import("./views/ReportStudentMajority.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/enrollment-trends",
    name: "overall-report-enrollment-trends",
    component: () => import("./views/ReportEnrollmentTrends.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/grade",
    name: "overall-report-grade",
    component: () => import("./views/ReportGradePage.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/subject-performance",
    name: "overall-report-subject-performance",
    component: () => import("./views/ReportSubjectPerformance.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/performance-groups",
    name: "overall-report-performance-groups",
    component: () => import("./views/ReportPerformanceGroups.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/top-scoring",
    name: "overall-report-top-scoring",
    component: () => import("./views/ReportTopScoringStudents.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/attendance",
    name: "overall-report-attendance",
    component: () => import("./views/ReportAttendancePage.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/top-absent",
    name: "overall-report-top-absent",
    component: () => import("./views/ReportTopAbsent.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  {
    path: "/overall-reports/teacher-teaching",
    name: "overall-report-teacher-teaching",
    component: () => import("./views/ReportTeacherTeaching.vue"),
    meta: { requiresAuth: true, isOverall: true },
  },
  // Central Reports (SUPERADMIN - all schools)
  {
    path: "/central-reports/student-school",
    name: "central-report-student-school",
    component: () => import("./views/CentralReportStudentBySchool.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/student-status",
    name: "central-report-student-status",
    component: () => import("./views/CentralReportStudentStatus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/overall-status",
    name: "central-report-overall-status",
    component: () => import("./views/CentralReportStudentOverallStatus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/student-gender",
    name: "central-report-student-gender",
    component: () => import("./views/CentralReportStudentGender.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/student-born-province",
    name: "central-report-student-born-province",
    component: () => import("./views/CentralReportStudentBornProvince.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/student-current-province",
    name: "central-report-student-current-province",
    component: () => import("./views/CentralReportStudentCurrentProvince.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/student-majority",
    name: "central-report-student-majority",
    component: () => import("./views/CentralReportStudentMajority.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/central-reports/grade",
    name: "central-report-grade",
    component: () => import("./views/CentralReportGradePage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "*",
    component: () => import("./views/student/ErrorPage.vue"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    window.location.pathname.startsWith("/public-register") &&
    !window.location.hash.includes("/public-register")
  ) {
    const search = window.location.search || "";
    window.location.replace(
      `${window.location.origin}/#/public-register${search}`
    );
    return;
  }

  const token = store.get("token");
  const user = store.get("user");
  const userRole = user ? user.role : null;
  console.log("ROUTER BEFORE EACH", to, token);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log("ROUTER CHECKING AUTH", token);
    if (!token) {
      if (
        to.path === "/student/login" ||
        to.path === "/teacher/login" ||
        to.path === "/librarian/login" ||
        to.path === "/login"
      ) {
        next();
      } else if (
        to.path.startsWith("/student") ||
        to.path.startsWith("/teacher") ||
        to.path.startsWith("/librarian")
      ) {
        next({ path: "/student/login", query: { redirect: to.fullPath } });
      } else {
        next({ path: "/login", query: { redirect: to.fullPath } });
      }
    } else {
      if (userRole === "REGISTRANT") {
        const allowedPaths = [
          "/home",
          "/register-student",
          "/pending-registrations",
          "/students",
          "/studentdetail",
          "/attendances",
          "/attendance",
          "/attendanceform",
          "/profile",
          "/public-register",
          "/all-notices",
        ];
        const isAllowed = allowedPaths.some(
          (p) => to.path === p || to.path.startsWith(p + "/")
        );
        if (!isAllowed) {
          next({ path: "/home" });
          return;
        }
      } else if (userRole === "GRADER") {
        const allowedPaths = [
          "/home",
          "/grades",
          "/grade",
          "/gradeform",
          "/score-deduction",
          "/reports/score-deduction",
          "/students",
          "/studentdetail",
          "/profile",
          "/all-notices",
        ];
        const isAllowed = allowedPaths.some(
          (p) => to.path === p || to.path.startsWith(p + "/")
        );
        if (!isAllowed) {
          next({ path: "/home" });
          return;
        }
      } else if (userRole === "LIBRARIAN") {
        const allowedPaths = [
          "/home",
          "/students",
          "/studentdetail",
          "/librarian",
          "/profile",
          "/all-notices",
        ];
        const isAllowed = allowedPaths.some(
          (p) => to.path === p || to.path.startsWith(p + "/")
        );
        if (!isAllowed) {
          next({ path: "/librarian/home" });
          return;
        }
      }
      next();
    }
  } else {
    next();
  }
});

router.onError((error) => {
  setTimeout(() => {
    const pattern = /Loading (CSS )?chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      console.log("reload");
      // window.location.reload();
    }
  }, 5000);
});

export default router;
